<template>
  <div class="mgText" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <ul>
      <li v-for="(item, index) in data.imgTextList" :style="{ 'margin-right': data.conStyle.tupianjg === '自定义' ? `${data.conStyle.space}px` : '15px' }" :key="index">
        <div>
          <img v-if="item.src" :src="item.src" alt="">
          <img v-else src="../../assets/image-upload.jpg" alt="">
        </div>
        <p :style="{ 'font-size': `${data.conStyle.titleSize}px`, 'color': data.conStyle.titleColor }">{{ item.name }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'imgTextPreview',
  props: {
    data: Object
  }
}
</script>
<style scoped>
.mgText {
  padding: 10px;
}

.mgText ul {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.mgText ul li {
  width: auto;
  flex: 1;
  overflow: hidden;
  margin-right: 15px;
}

.mgText ul li div {
  display: block;
  padding-top: 66.66%;
  overflow: hidden;
  position: relative;
}

.mgText ul li div img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  position: absolute;
  left: 0;
  top: 0;
}

.mgText ul li p {
  text-align: center;
}

.mgText ul li:last-child {
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/imgText/imgTextPreview.vue